import {HostListener, inject, Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {BreakpointObserver} from "@angular/cdk/layout";

@Injectable({
	providedIn: "root",
})
export class SimWindowService {
	private readonly isTwoScreenSource = new BehaviorSubject<boolean>(false);
	public readonly isTwoScreen = this.isTwoScreenSource.asObservable();
	readonly observer = inject(BreakpointObserver);

	public get isTwoScreenVal() {
		return this.isTwoScreenSource.value;
	}

	constructor() {
		this.observer.observe("(max-width: 1920px)").subscribe(() => this.updateTwoScreen());
	}

	@HostListener("window:resize", ["$event"])
	private updateTwoScreen() {
		const width: number = window.innerWidth;
		const height: number = window.innerHeight;

		const setTwoScreen = (isTwoScreen: boolean) => {
			if (this.isTwoScreenVal !== isTwoScreen) {
				this.isTwoScreenSource.next(isTwoScreen);
				if (isTwoScreen) {
					document.body.classList.add("twoScreenApplicationEnabled");
				} else {
					document.body.classList.remove("twoScreenApplicationEnabled");
				}
			}
		};

		if (width / height > 3.1111) {
			setTwoScreen(true);
		} else {
			setTwoScreen(false);
		}
	}
}
